import { Fold, Traversal } from "@discovery/prelude/lib/control/lens";
import { _Route2Attributes, _Route2Target, } from "@discovery/sonic-api-ng-optics-gen/lib/route";
export * from "@discovery/sonic-api-ng-optics-gen/lib/route";
export const _Route2AttributesFiltered = ({ canonical = true, }) => Fold.compose(_Route2Attributes, Traversal._filtered((attr) => canonical === attr.canonical));
export const _Route2Page = _Route2Target;

